<template>
    <b-card-actions action-collapse title="Amenities">
        <b-row>
         <b-col md="12">
                <b-form-group class="mb-0">
                  <div class="facility-checkbox-grid">
                    <b-form-checkbox
                      v-for="facility in facilityOptions"
                      :key="facility.value"
                      v-model="input.facilityId"
                      :value="facility.value"
                      name="facility_id"
                      class="facility-checkbox-item"
                      @change="emitToParent"
                    >
                      <img
                        v-if="facility.icon"
                        :src="facility.icon"
                        class="facility-icon"
                        alt=""
                      />
                      {{ facility.text }}
                    </b-form-checkbox>
                  </div>
                </b-form-group>
          </b-col>

        </b-row>

    </b-card-actions>
</template>
<script>

import { VueAutosuggest } from 'vue-autosuggest'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,BFormSpinbutton,
  BFormCheckbox
} from 'bootstrap-vue'
import { BFormTextarea, BCardText } from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'
export default {
  components: {
    BCardActions,
    BCardText,
    BFormTextarea,
    VueAutosuggest,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox
  },
  data() {
     return {
       
       facilities:[],
       selected:[],
       //facility_id:[],
       input:{
         facilityId:[]
       }
      
     }
  },
  props: {
    parentData: {
      type: Object,
      
    },
    id:{
      type: [String, Number]
    }
  },
  created() {
      let queryParams = {
        type_code:'2',
        is_active: 1,
        order_by: "FIRST_LETTER ASC"
      }

     var data = JSON.stringify(queryParams);
      axios.post('facility/v1/lists', data)
      .then(res => { 
        this.facilities = res.data.data; 
      })

      if(this.id != undefined){
        this.getFacs();
      }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
    facilityOptions() {
      const locale = this.currentLocale || 'en';
      return this.facilities
        .filter(facility => facility.is_active)
        .map(facility => ({
          text: facility.name[locale] || facility.name.en || 'Unnamed',
          value: facility.id,
          icon: facility.filename
        }));
    },
  },
  methods: {
    async getFacs(){
      let facs = await axios.get('property/v1/getfacilities/'+this.id);
      let fa = [];

      const facilityData = facs?.data?.data
      if(facilityData.length > 0){
        facilityData.filter(item => {
          fa.push(item.facility_id);
        });
      }

      this.input.facilityId = fa;
    },
     emitToParent(event){
       console.log('event',this.input);
      this.$emit('childToParent', this.input)
     
    },
  }
}
</script>

<style scoped>
.facility-checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 1rem;
}

.facility-checkbox-grid ::v-deep .custom-control {
  display: block;
  width: 100%;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.facility-checkbox-grid ::v-deep .custom-control-label {
  line-height: 1.25rem;
  display: inline-flex;
  align-items: center;
}

.facility-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  object-fit: contain;
}

.facility-checkbox-grid ::v-deep .custom-control-label::before,
.facility-checkbox-grid ::v-deep .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}

</style>